export enum Stage {
  PRO = 'pro',
  BOX = 'box',
  LOC = 'loc',
}

export const isProduction = () => process.env.STAGE?.toLowerCase() === Stage.PRO;
export const isLocal = () =>
  process.env.STAGE?.toLowerCase() !== Stage.PRO && process.env.STAGE?.toLowerCase() !== Stage.BOX;
